import { mapActions, mapState } from "vuex"

/**
 * Handle profile update submit action
 */
export default {
  props: {
    /**
     * Endpoint to be used
     */
    endpoint: {
      type: String,
      default: 'name'
    },
    /**
     * Method to be used
     */
    method: {
      type: String,
      default: 'patch'
    }
  },
  data: () => ({
    isLoading: false
  }),
  computed: {
    ...mapState('auth', ['isUpdateProfilePending'])
  },
  watch: {
    isUpdateProfilePending(val) {
      this.form.find('input, select, textarea').prop('disabled', val)
      this.$emit('loading', val)
    }
  },
  methods: {
    ...mapActions('auth', ['updateProfile']),
    submitAction(data) {
      return this.updateProfile({ data, endpoint: this.endpoint, method: this.method.toLowerCase() })
    },
  }
}